import React from "react";
import MenuBar from "./MenuPanel";
import FooterPanel from "./FooterPanel";
import { useTranslation } from 'react-i18next';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation('footer');

  return (
    <React.Fragment>
      {/* Menu */}
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      {/* Title Section with Overlay */}
      <section className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">{t('privacyPolicy')}</h1>
          </div>
        </div>
      </section>

      {/* Main Content - PDF Display */}
      <main className="container-fluid px-2 px-md-4 mt-3 mt-md-4 mb-4 mb-md-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-11 col-xl-10">
            <div 
              className="pdf-container" 
              style={{ 
                height: "calc(100vh - 250px)",
                minHeight: "400px",
                maxHeight: "900px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                overflow: "hidden"
              }}
            >
              <iframe
                src={`${process.env.PUBLIC_URL}/policy/Privacy Policy NewsLetter.pdf`}
                width="100%"
                height="100%"
                title={t('privacyPolicy')}
                style={{ border: "none" }}
              />
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <FooterPanel />
    </React.Fragment>
  );
};

export default PrivacyPolicyPage;
